import React, { useContext, useMemo } from "react";
import { ModalContext } from "../../Context/ModalContext";

import { Dialog } from "@material-ui/core";

import Map from "./Map";

import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import {
  hasLeagueEmailAccess,
  hasLeaguePhoneAccess,
} from "../../utils/helpers";

const useStyles = makeStyles(() => ({
  modalContainer: {
    width: "500px",
    height: "600px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    height: "350px",
    padding: "25px 0px",
    width: "auto",
  },
  contentBox1: {
    textAlign: "center",
  },
  contentBox2: {
    textAlign: "left",
    width: "300px",
    color: "red",
  },
  contentBox3: {
    textAlign: "left",
    width: "300px",
  },
  p2a: {
    borderTop: "1px solid lightGrey",
    borderBottom: "1px solid lightGrey",
    padding: "10px",
  },
  p2b: {
    borderBottom: "1px solid lightGrey",
    padding: "10px",
  },
  p2b: {
    borderBottom: "1px solid lightGrey",
    padding: "10px",
  },
  button: {
    backgroundColor: "red",
    borderRadius: "20px",
    color: "white",
    border: "none",
    padding: "10px 15px",
    fontSize: "14px",
    textDecoration: "none",
  },
}));

const Modal = () => {
  const classes = useStyles();
  const { ModalState, showModalHandler } = useContext(ModalContext);
  const { show, contactInfo } = ModalState;
  const user = useSelector((state) => state.user?.data);

  const phone = useMemo(() => {
    return hasLeaguePhoneAccess(contactInfo, user)
      ? contactInfo?.phone
      : contactInfo?.phone
          ?.split("")
          ?.map((char, index) =>
            index > contactInfo?.phone?.length - 8 ? "*" : char
          )
          ?.join("");
  }, [contactInfo, user]);

  const email = useMemo(() => {
    return hasLeagueEmailAccess(contactInfo, user)
      ? contactInfo?.email
      : contactInfo?.email
          ?.split("@")
          ?.map((part, index) => (index === 1 ? "*" : part))
          ?.join("@");
  }, [contactInfo, user]);

  const hasLocation = useMemo(() => {
    return contactInfo?.lat &&
      contactInfo?.lon &&
      parseFloat(contactInfo?.lat) &&
      parseFloat(contactInfo?.lon)
      ? true
      : false;
  }, [contactInfo?.lat, contactInfo?.lon]);

  return (
    <Dialog open={show} onClose={showModalHandler}>
      <div className={classes.modalContainer}>
        {hasLocation && (
          <Map
            relatedPins={[]}
            thisPin={[
              parseFloat(contactInfo?.lat),
              parseFloat(contactInfo?.lon),
            ]}
            modal
          />
        )}
        <div className={classes.content}>
          <div className={classes.contentBox1}>
            <h3>{contactInfo.name}</h3>
            <h4>{contactInfo.companyName}</h4>
            <p>{contactInfo.service}</p>
            <p>
              {contactInfo.location
                ?.replace("undefined", "")
                ?.replace("null", "")}
            </p>
          </div>
          <div className={classes.contentBox2}>
            {!!phone && <p className={classes.p2a}>{phone}</p>}
            {!!email && <p className={classes.p2b}>{email}</p>}
          </div>
          {!!contactInfo.description && (
            <div className={classes.contentBox3}>
              <p className={classes.p2b}>{contactInfo.description}</p>
            </div>
          )}
          {contactInfo.location && (
            <a
              href={`http://maps.google.com/?q=${contactInfo.location}`}
              className={classes.button}
              target="_blank"
              rel="noreferrer"
              style={{
                marginTop: "10px",
                marginBottom: "30px",
              }}
            >
              Get Directions
            </a>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default Modal;
